import styled from '@emotion/styled';

import { useDispatch } from 'react-redux';

import { useEffect, useMemo } from 'react';

import { useInView } from 'react-intersection-observer';

import BoardHeader from './BoardHeader';
import BoardTable from './BoardTable';
import BoardTableBottomContainer from './BoardTableBottomContainer';
import ProductInquiryRegisterFormContainer
  from './form/ProductInquiryRegisterFormContainer';
import { useAppSelector } from '../../../shared/store';
import {
  initProductInquiryItems,
  loadProductInquiryItems,
  modifyProductInquiryForm,
} from '../../detail/slice';

const Container = styled.div`
  margin-bottom: 60px;
`;

interface Props {
  no: number;
  name: string;
  mainImageUrl: string;
}

export default function ProductInquiryBoardContainer({
  no, name, mainImageUrl,
}: Props) {
  const { inView, ref } = useInView();

  const { isGuest, accessToken } = useAppSelector(({ auth }) => auth);
  const { inquiry } = useAppSelector(({ productDetail }) => productDetail);
  const { open } = inquiry.form;
  const { loading, items, pagination, isError } = inquiry;
  const { currentPage, perPage } = pagination;

  const dispatch = useDispatch();

  useEffect(() => {
    if (!inView || !accessToken) {
      return;
    }

    dispatch(loadProductInquiryItems(no, currentPage));
  }, [dispatch, accessToken, currentPage, no, inView]);

  useEffect(() => {
    if (!accessToken) {
      return;
    }

    dispatch(initProductInquiryItems());
  }, [accessToken, dispatch, no]);

  const closeInquiryModal = () => {
    dispatch(modifyProductInquiryForm({
      open: false,
    }));
  };

  const currentPageItems = useMemo(() => {
    const start = (currentPage - 1) * perPage;
    return items.slice(start, start + perPage);
  }, [items, currentPage, perPage]);

  return (
    <Container ref={ref}>
      <BoardHeader />
      <BoardTable
        loading={loading}
        isError={isError}
        items={currentPageItems}
        pageSize={perPage}
      />
      <BoardTableBottomContainer
        pagination={pagination}
      />
      <ProductInquiryRegisterFormContainer
        productNo={no}
        productName={name}
        productImageUrl={mainImageUrl}
        open={open}
        isGuest={isGuest}
        onClose={closeInquiryModal}
      />
    </Container>
  );
}
